// Main entry point — registers components and resolves the session before render.

import './components/app-root.js'
import './components/app-nav.js'
import './components/app-router.js'
import './components/app-toast.js'
import './components/page-home.js'
import './components/page-not-found.js'
import './components/page-login.js'
import './components/page-register.js'
import './components/page-reset.js'
import './components/page-verify.js'
import './components/page-csat.js'
import './components/page-tickets.js'
import './components/page-triage.js'
import './components/ticket-row.js'
import './components/page-ticket.js'
import './components/ticket-thread.js'
import './components/ticket-reply.js'
import './components/ticket-sidebar.js'
import './components/page-clients.js'
import './components/page-client.js'
import './components/page-groups.js'
import './components/page-agents.js'
import './components/page-reports.js'
import './components/page-subscriptions.js'
import './components/page-connections.js'
import './components/page-api-keys.js'
import './components/page-authorize.js'
import './components/page-kb.js'
import './components/page-kb-article.js'

import { bootstrapAuth } from './bootstrap.js'

bootstrapAuth()
